import gql from 'graphql-tag';

export const CREATE_INVITATION_MUTATION = gql`
  mutation assign($token: String, $ticketId: Int!) {
    viewer(token: $token) {
      invitationAccessKey: assignTicket(ticketId: $ticketId)
    }
  }
`;
